<template>
  <div>
    <el-card>
      <b-row>
        <b-col cols="auto" class="mr-auto">
          <h6>{{ $l('v_scm_visit_title') || '拜访记录' }}</h6>
        </b-col>
        <b-col cols="auto">
          <a v-b-toggle.collapse-visit role="button" style="color: #606266">
            <i v-if="isShowPanel" class="fa fa-chevron-down" title="收起"></i>
            <i v-else class="fa fa-chevron-up" title="展开"></i>
          </a>
        </b-col>
      </b-row>

      <b-collapse v-model="isShowPanel" id="collapse-visit">
        <b-row>
          <b-col>
            <el-timeline
              style="padding: 0px;height: 500px;overflow-y: auto;"
              class="mt-3"
            >
              <p v-if="isNoData" class="p-style">
                {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
              </p>
              <el-timeline-item
                v-for="(item, index) in tableData"
                :key="index"
                :icon="index === 0 ? 'el-icon-more' : ''"
                :type="index === 0 ? 'primary' : ''"
                :color="index === 0 ? '#0bbd87' : ''"
                :size="index === 0 ? 'large' : 'normal'"
                :timestamp="item.visitDate"
                placement="top"
              >
                <div>
                  <span style="font-size: 18px; color: #444444">{{
                    item.visitTitle
                  }}</span>
                  <br />
                  <span style="color: #007bff">{{ item.visitPerson }}</span>
                  <el-divider direction="vertical"></el-divider>
                  <span style="color: #444444"
                    >{{ $l('v_scm_visit_factory_person_label') || '厂方人员：'
                    }}{{ item.scmPerson }}</span
                  >
                  <div class="mt-2" v-if="item.visitDescription">
                    <p
                      style="
                        font-size: 14px;
                        color: #606266;
                        white-space: pre-line;
                      "
                      v-html="item.visitDescription"
                    ></p>
                  </div>
                  <div class="mt-2" v-if="item.visitImageList">
                    <swiper :options="swiperOption">
                      <swiper-slide
                        v-for="(itemImage, index) in filterImage(item.visitImageList)"
                        :key="index"
                      >
                        <div class="swiper-zoom-container">
                          <img
                            :src="itemImage.scmImageUrl"
                            @click="imageView(index, filterImage(item.visitImageList))"
                          />
                        </div>
                      </swiper-slide>
                      <div class="swiper-pagination" slot="pagination"></div>
                      <div class="swiper-button-prev" slot="button-prev">
                        <i class="fa fa-chevron-circle-left icon-font" />
                      </div>
                      <div class="swiper-button-next" slot="button-next">
                        <i class="fa fa-chevron-circle-right icon-font" />
                      </div>
                    </swiper>
                  </div>
                  <div
                    class="d-flex justify-content-between mt-2"
                    v-for="(itemScore, index) in item.listScore"
                    :key="index"
                  >
                    <div>
                      <span class="text-muted" style="font-size: 14px"
                        >Score By：</span
                      >
                      <span class="text-muted" style="font-size: 14px"
                        >{{ itemScore.scoreByName }} at
                        {{ itemScore.scoreTime }}
                      </span>
                    </div>
                    <div>
                      <span class="text-muted" style="font-size: 14px"
                        >Score：</span
                      >
                      <span style="font-size: 14px">{{
                        itemScore.score ? itemScore.score : '--'
                      }}</span>
                      <el-divider direction="vertical"></el-divider>
                      <a
                        style="color: #007bff"
                        @click="openVisitScore(itemScore)"
                        role="button"
                        >View detail</a
                      >
                    </div>
                  </div>
                </div>
              </el-timeline-item>
            </el-timeline>
          </b-col>
        </b-row>
      </b-collapse>
      <div v-show="false" ref="viewBigVisitImage" v-viewer="{ movable: true }">
        <img
          v-for="src in viewerImageList"
          :src="src.scmImageUrl"
          :key="src.scmImageCode"
        />
      </div>
    </el-card>
    <el-dialog
      :visible.sync="dialogVisible"
      width="950px"
      :modal="true"
      :show-close="true"
      :title="dialogTitle"
      top="10vh"
      center
    >
      <visit-score ref="score" />
    </el-dialog>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import VisitScore from './visitscore'
export default {
  components: { Swiper, SwiperSlide, VisitScore },
  props: {
    params: {
      default: null,
      type: Object,
    },
    autoLoad: {
      default: false,
      type: Boolean,
    },
  },
  watch: {
    params: {
      handler() {
        if (this.params.scmCode) {
          this.init(this.params)
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      isShowPanel: true,
      isNoData: false,
      dialogTitle: '',
      dialogVisible: false,
      scmCode: '',
      tableData: [],
      swiperOption: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 10,
        loop: false,
        loopFillGroupWithBlank: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      viewerImageList: [],
    }
  },
  computed: {},
  methods: {
    init(params) {
      this.getData(params)
    },
    getData(params) {
      if (!params.scmCode) {
        return
      }
      this.isBusy = true
      this.$api
        .scmInfoVisitListTimeLineApi(params)
        .then((res) => {
          this.isBusy = false
          this.tableData = res.body.data
          if (!this.tableData.length > 0) {
            this.isNoData = true
          }
          this.tableData.forEach((item) => {
            if (item.visitDescription !== null) {
              item.visitDescription = item.visitDescription
                .replace(/ /g, '&nbsp;')
                .replace(/\n/g, '<br/>')
            }
          })
        })
        .catch(() => {
          this.isBusy = false
        })
    },
    // 点击大图显示图片预览组件
    imageView(index, imageList) {
      if (imageList.length > 0) {
        const viewer = this.$refs.viewBigVisitImage.$viewer
        this.viewerImageList = imageList
        viewer.view(index)
        viewer.show()
      }
    },
    openVisitScore(row) {
      let params = {
        visitScoreCode: row.visitScoreCode,
      }
      this.getVisitScoreData(params)
    },
    getVisitScoreData(params) {
      this.isBusy = true
      this.$api
        .scmInfoVisitScoreApi(params)
        .then((res) => {
          this.isBusy = false
          if (res.body != null) {
            this.dialogTitle = res.body.appraisalBillName
            this.popShow(res.body)
          } else {
            this.$message.warning(
              this.$l('v_tips_no_score') || '没有供应商评分记录'
            )
            this.dialogVisible = false
          }
        })
        .catch(() => {
          this.isBusy = false
        })
    },
    popShow(data) {
      setTimeout(() => {
        this.$refs.score.showData(data)
      }, 100)
      this.dialogVisible = true
    },
    //过滤图片数据
    filterImage(data){
      const filter = ['jpeg','png','jpg','gif']
      return data.filter((item) => {
        return filter.includes(item.scmImageCode.substring(item.scmImageCode.indexOf('.') + 1))
      })
    }
  },
}
</script>
<style lang="scss" scoped>
.swiper-button-next {
  right: 10px;
  margin-top: -1.2rem;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 100%;
  opacity: 0.3;

  &:hover {
    opacity: 0.9;
  }

  &::after {
    content: none;
  }
}

.swiper-button-prev {
  left: 10px;
  margin-top: -1.2rem;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 100%;
  opacity: 0.3;

  &:hover {
    opacity: 0.9;
  }

  &::after {
    content: none;
  }
}

.icon-font {
  font-size: 2.2rem;
}
.p-style {
  width: 100%;
  text-align: center;
  line-height: 400px;
  font-size: 16px;
}
</style>
